// import React, { useState } from 'react';

// const UpdateStatusModal = ({ project, onClose, onSuccess, authTokens }) => {
//   const [formData, setFormData] = useState({
//     project: project.id,
//     status: '',
//     remarks: ''
//   });
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://ess-api-django-a6fc2c26f42e.herokuapp.com';

//   const statusOptions = [
//     { value: 'GOING_SMOOTH', label: 'Going Smooth', icon: '✅', color: '#10b981' },
//     { value: 'ON_HOLD', label: 'On Hold', icon: '⏸️', color: '#f59e0b' },
//     { value: 'CRITICAL', label: 'Critical/Dangerous', icon: '🚨', color: '#ef4444' },
//     { value: 'CLOSED', label: 'Closed', icon: '✔️', color: '#6b7280' }
//   ];

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (!formData.status) {
//       setError('Please select a status');
//       return;
//     }
    
//     if (!formData.remarks.trim()) {
//       setError('Please provide remarks');
//       return;
//     }

//     try {
//       setLoading(true);
//       setError(null);
      
//       const response = await fetch(`${API_BASE_URL}/api/timesheet/project-status/create_status/`, {
//         method: 'POST',
//         headers: {
//           Authorization: "Bearer " + String(authTokens.access),
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(formData)
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.detail || 'Failed to update status');
//       }

//       onSuccess();
//     } catch (err) {
//       setError(err.message || 'Failed to update status');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const styles = {
//     overlay: {
//       position: 'fixed',
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       backgroundColor: 'rgba(0, 0, 0, 0.5)',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       zIndex: 1000,
//       padding: '20px'
//     },
//     modal: {
//       backgroundColor: 'white',
//       borderRadius: '12px',
//       maxWidth: '600px',
//       width: '100%',
//       maxHeight: '90vh',
//       overflow: 'auto',
//       boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
//     },
//     header: {
//       padding: '24px',
//       borderBottom: '1px solid #e5e7eb',
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center'
//     },
//     title: {
//       fontSize: '20px',
//       fontWeight: '600',
//       color: '#111827',
//       margin: 0
//     },
//     closeBtn: {
//       background: 'none',
//       border: 'none',
//       fontSize: '28px',
//       cursor: 'pointer',
//       color: '#6b7280',
//       lineHeight: '1',
//       padding: '0',
//       width: '32px',
//       height: '32px',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       borderRadius: '6px'
//     },
//     body: {
//       padding: '24px'
//     },
//     projectInfo: {
//       backgroundColor: '#f9fafb',
//       padding: '16px',
//       borderRadius: '8px',
//       marginBottom: '24px'
//     },
//     projectInfoTitle: {
//       fontSize: '16px',
//       fontWeight: '600',
//       color: '#111827',
//       margin: '0 0 4px 0'
//     },
//     projectInfoSubtitle: {
//       fontSize: '14px',
//       color: '#6b7280',
//       margin: 0
//     },
//     formGroup: {
//       marginBottom: '24px'
//     },
//     label: {
//       display: 'block',
//       fontSize: '14px',
//       fontWeight: '500',
//       color: '#374151',
//       marginBottom: '8px'
//     },
//     statusOptions: {
//       display: 'grid',
//       gridTemplateColumns: 'repeat(2, 1fr)',
//       gap: '12px'
//     },
//     statusOption: (isSelected, color) => ({
//       border: `2px solid ${isSelected ? color : '#e5e7eb'}`,
//       borderRadius: '8px',
//       padding: '12px',
//       cursor: 'pointer',
//       transition: 'all 0.2s',
//       backgroundColor: isSelected ? `${color}10` : 'white'
//     }),
//     statusOptionContent: {
//       display: 'flex',
//       alignItems: 'center',
//       gap: '8px'
//     },
//     statusIcon: {
//       fontSize: '20px'
//     },
//     statusLabel: {
//       fontSize: '14px',
//       fontWeight: '500',
//       color: '#374151'
//     },
//     hiddenRadio: {
//       display: 'none'
//     },
//     textarea: {
//       width: '100%',
//       padding: '12px',
//       border: '1px solid #d1d5db',
//       borderRadius: '6px',
//       fontSize: '14px',
//       fontFamily: 'inherit',
//       resize: 'vertical',
//       boxSizing: 'border-box'
//     },
//     charCount: {
//       fontSize: '12px',
//       color: '#6b7280',
//       marginTop: '4px',
//       display: 'block'
//     },
//     errorMessage: {
//       backgroundColor: '#fee2e2',
//       color: '#991b1b',
//       padding: '12px',
//       borderRadius: '6px',
//       fontSize: '14px',
//       marginBottom: '16px'
//     },
//     footer: {
//       display: 'flex',
//       gap: '12px',
//       justifyContent: 'flex-end'
//     },
//     btnCancel: {
//       padding: '10px 20px',
//       border: '1px solid #d1d5db',
//       borderRadius: '6px',
//       fontSize: '14px',
//       fontWeight: '500',
//       cursor: 'pointer',
//       backgroundColor: 'white',
//       color: '#374151',
//       transition: 'all 0.2s'
//     },
//     btnSubmit: {
//       padding: '10px 20px',
//       border: 'none',
//       borderRadius: '6px',
//       fontSize: '14px',
//       fontWeight: '500',
//       cursor: 'pointer',
//       backgroundColor: '#3b82f6',
//       color: 'white',
//       transition: 'all 0.2s'
//     }
//   };

//   return (
//     <div style={styles.overlay} onClick={onClose}>
//       <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
//         <div style={styles.header}>
//           <h2 style={styles.title}>Update Project Status</h2>
//           <button 
//             style={styles.closeBtn}
//             onClick={onClose}
//             onMouseOver={(e) => e.target.style.backgroundColor = '#f3f4f6'}
//             onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
//           >
//             &times;
//           </button>
//         </div>

//         <div style={styles.body}>
//           <div style={styles.projectInfo}>
//             <h3 style={styles.projectInfoTitle}>{project.project_name}</h3>
//             <p style={styles.projectInfoSubtitle}>Manager: {project.project_manager?.name}</p>
//           </div>

//           <form onSubmit={handleSubmit}>
//             <div style={styles.formGroup}>
//               <label style={styles.label}>Select Status *</label>
//               <div style={styles.statusOptions}>
//                 {statusOptions.map(option => (
//                   <label 
//                     key={option.value}
//                     style={styles.statusOption(formData.status === option.value, option.color)}
//                   >
//                     <input
//                       type="radio"
//                       name="status"
//                       value={option.value}
//                       checked={formData.status === option.value}
//                       onChange={(e) => setFormData({ ...formData, status: e.target.value })}
//                       style={styles.hiddenRadio}
//                     />
//                     <div style={styles.statusOptionContent}>
//                       <span style={styles.statusIcon}>{option.icon}</span>
//                       <span style={styles.statusLabel}>{option.label}</span>
//                     </div>
//                   </label>
//                 ))}
//               </div>
//             </div>

//             <div style={styles.formGroup}>
//               <label htmlFor="remarks" style={styles.label}>Remarks *</label>
//               <textarea
//                 id="remarks"
//                 rows="4"
//                 placeholder="Provide context or details about this status update..."
//                 value={formData.remarks}
//                 onChange={(e) => setFormData({ ...formData, remarks: e.target.value })}
//                 required
//                 style={styles.textarea}
//               />
//               <small style={styles.charCount}>{formData.remarks.length} characters</small>
//             </div>

//             {error && (
//               <div style={styles.errorMessage}>
//                 {error}
//               </div>
//             )}

//             <div style={styles.footer}>
//               <button 
//                 type="button" 
//                 style={styles.btnCancel}
//                 onClick={onClose}
//                 disabled={loading}
//                 onMouseOver={(e) => !loading && (e.target.style.backgroundColor = '#f9fafb')}
//                 onMouseOut={(e) => !loading && (e.target.style.backgroundColor = 'white')}
//               >
//                 Cancel
//               </button>
//               <button 
//                 type="submit" 
//                 style={{
//                   ...styles.btnSubmit,
//                   opacity: loading ? 0.7 : 1,
//                   cursor: loading ? 'not-allowed' : 'pointer'
//                 }}
//                 disabled={loading}
//                 onMouseOver={(e) => !loading && (e.target.style.backgroundColor = '#2563eb')}
//                 onMouseOut={(e) => !loading && (e.target.style.backgroundColor = '#3b82f6')}
//               >
//                 {loading ? 'Updating...' : 'Update Status'}
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UpdateStatusModal;

import React, { useState, useEffect } from 'react';

const UpdateStatusModal = ({ project, statusToEdit, onClose, onSuccess, authTokens }) => {
  const [formData, setFormData] = useState({
    project: project.id,
    status: '',
    remarks: '',
    google_drive_link: '',
    pending_tasks: [],
    outsource_resources: []
  });
  const [attachmentFile, setAttachmentFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('basic'); // basic, tasks, outsource

  const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://ess-api-django-a6fc2c26f42e.herokuapp.com';

  useEffect(() => {
    if (statusToEdit) {
      // Pre-fill form when editing
      setFormData({
        project: project.id,
        status: statusToEdit.status,
        remarks: statusToEdit.remarks || '',
        google_drive_link: statusToEdit.google_drive_link || '',
        pending_tasks: statusToEdit.pending_tasks || [],
        outsource_resources: statusToEdit.outsource_resources || []
      });
    }
  }, [statusToEdit]);

  const statusOptions = [
    { value: 'GOING_SMOOTH', label: 'Going Smooth', icon: '✅', color: '#10b981' },
    { value: 'ON_HOLD', label: 'On Hold', icon: '⏸️', color: '#f59e0b' },
    { value: 'CRITICAL', label: 'Critical/Dangerous', icon: '🚨', color: '#ef4444' },
    { value: 'READY_TO_OUTSOURCE', label: 'Ready to Outsource', icon: '🤝', color: '#8b5cf6' },
    { value: 'CLOSED', label: 'Closed', icon: '✔️', color: '#6b7280' }
  ];

  // Pending Tasks Functions
  const addPendingTask = () => {
    // Clear any previous errors when adding tasks
    setError(null);
    
    const newTask = {
      sl_no: formData.pending_tasks.length + 1,
      task_description: '',
      resource: '',
      task_status: 'PENDING',
      closing_date: ''
    };
    setFormData(prev => ({
      ...prev,
      pending_tasks: [...prev.pending_tasks, newTask]
    }));
  };

  const removePendingTask = (index) => {
    setFormData(prev => ({
      ...prev,
      pending_tasks: prev.pending_tasks.filter((_, i) => i !== index)
    }));
  };

  const updatePendingTask = (index, field, value) => {
    setFormData(prev => ({
      ...prev,
      pending_tasks: prev.pending_tasks.map((task, i) => 
        i === index ? { ...task, [field]: value } : task
      )
    }));
  };

  // Outsource Resources Functions
  const addOutsourceResource = () => {
    const newResource = {
      sl_no: formData.outsource_resources.length + 1,
      resource_name: '',
      roles: '',
      years_of_experience: 0,
      projects_worked_on: ''
    };
    setFormData(prev => ({
      ...prev,
      outsource_resources: [...prev.outsource_resources, newResource]
    }));
  };

  const removeOutsourceResource = (index) => {
    setFormData(prev => ({
      ...prev,
      outsource_resources: prev.outsource_resources.filter((_, i) => i !== index)
    }));
  };

  const updateOutsourceResource = (index, field, value) => {
    setFormData(prev => ({
      ...prev,
      outsource_resources: prev.outsource_resources.map((resource, i) => 
        i === index ? { ...resource, [field]: value } : resource
      )
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.status) {
      setError('Please select a status');
      return;
    }
    
    if (!formData.remarks.trim()) {
      setError('Please provide remarks');
      return;
    }

    // Validate status-specific requirements
    if (formData.status === 'READY_TO_OUTSOURCE' && formData.outsource_resources.length === 0) {
      setError('Please add at least one outsource resource for "Ready to Outsource" status');
      return;
    }

    try {
      setLoading(true);
      setError(null);
      
      const formDataToSend = new FormData();
      formDataToSend.append('project', formData.project);
      formDataToSend.append('status', formData.status);
      formDataToSend.append('remarks', formData.remarks);
      
      if (formData.google_drive_link) {
        formDataToSend.append('google_drive_link', formData.google_drive_link);
      }
      
      if (attachmentFile) {
        formDataToSend.append('attachment_file', attachmentFile);
      }
      
      if (formData.pending_tasks.length > 0) {
        formDataToSend.append('pending_tasks', JSON.stringify(formData.pending_tasks));
      }
      
      if (formData.outsource_resources.length > 0) {
        formDataToSend.append('outsource_resources', JSON.stringify(formData.outsource_resources));
      }

      const url = statusToEdit 
        ? `${API_BASE_URL}/api/timesheet/project-status/update_status/${statusToEdit.id}/`
        : `${API_BASE_URL}/api/timesheet/project-status/create_status/`;
      
      const method = statusToEdit ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method: method,
        headers: {
          Authorization: "Bearer " + String(authTokens.access),
        },
        body: formDataToSend
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Failed to update status');
      }

      onSuccess();
    } catch (err) {
      setError(err.message || 'Failed to update status');
    } finally {
      setLoading(false);
    }
  };

  const styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '20px'
    },
    modal: {
      backgroundColor: 'white',
      borderRadius: '12px',
      maxWidth: '900px',
      width: '100%',
      maxHeight: '90vh',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)'
    },
    header: {
      padding: '24px',
      borderBottom: '1px solid #e5e7eb',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    title: {
      fontSize: '20px',
      fontWeight: '600',
      color: '#111827',
      margin: 0
    },
    closeBtn: {
      background: 'none',
      border: 'none',
      fontSize: '28px',
      cursor: 'pointer',
      color: '#6b7280',
      lineHeight: '1',
      padding: '0',
      width: '32px',
      height: '32px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '6px'
    },
    body: {
      padding: '24px',
      overflowY: 'auto',
      flex: 1
    },
    projectInfo: {
      backgroundColor: '#f9fafb',
      padding: '16px',
      borderRadius: '8px',
      marginBottom: '24px'
    },
    projectInfoTitle: {
      fontSize: '16px',
      fontWeight: '600',
      color: '#111827',
      margin: '0 0 4px 0'
    },
    projectInfoSubtitle: {
      fontSize: '14px',
      color: '#6b7280',
      margin: 0
    },
    tabs: {
      display: 'flex',
      borderBottom: '2px solid #e5e7eb',
      marginBottom: '24px'
    },
    tab: (isActive) => ({
      padding: '12px 24px',
      backgroundColor: 'transparent',
      border: 'none',
      borderBottom: isActive ? '3px solid #3b82f6' : '3px solid transparent',
      fontSize: '14px',
      fontWeight: isActive ? '600' : '500',
      color: isActive ? '#3b82f6' : '#6b7280',
      cursor: 'pointer',
      transition: 'all 0.2s'
    }),
    formGroup: {
      marginBottom: '20px'
    },
    label: {
      display: 'block',
      fontSize: '14px',
      fontWeight: '500',
      color: '#374151',
      marginBottom: '8px'
    },
    statusOptions: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
      gap: '12px'
    },
    statusOption: (isSelected, color) => ({
      border: `2px solid ${isSelected ? color : '#e5e7eb'}`,
      borderRadius: '8px',
      padding: '12px',
      cursor: 'pointer',
      transition: 'all 0.2s',
      backgroundColor: isSelected ? `${color}10` : 'white'
    }),
    statusOptionContent: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    statusIcon: {
      fontSize: '20px'
    },
    statusLabel: {
      fontSize: '13px',
      fontWeight: '500',
      color: '#374151'
    },
    hiddenRadio: {
      display: 'none'
    },
    textarea: {
      width: '100%',
      padding: '12px',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      fontSize: '14px',
      fontFamily: 'inherit',
      resize: 'vertical',
      boxSizing: 'border-box',
      maxHeight: '150px',
      overflowY: 'auto'
    },
    input: {
      width: '100%',
      padding: '10px 12px',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      fontSize: '14px',
      boxSizing: 'border-box'
    },
    fileInput: {
      padding: '10px 12px',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      fontSize: '14px',
      boxSizing: 'border-box',
      cursor: 'pointer'
    },
    charCount: {
      fontSize: '12px',
      color: '#6b7280',
      marginTop: '4px',
      display: 'block'
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      marginTop: '12px'
    },
    tableHeader: {
      backgroundColor: '#f9fafb',
      padding: '10px',
      textAlign: 'left',
      fontSize: '13px',
      fontWeight: '600',
      color: '#374151',
      borderBottom: '2px solid #e5e7eb'
    },
    tableCell: {
      padding: '8px',
      borderBottom: '1px solid #e5e7eb'
    },
    tableInput: {
      width: '100%',
      padding: '6px 8px',
      border: '1px solid #d1d5db',
      borderRadius: '4px',
      fontSize: '13px',
      boxSizing: 'border-box'
    },
    tableSelect: {
      width: '100%',
      padding: '6px 8px',
      border: '1px solid #d1d5db',
      borderRadius: '4px',
      fontSize: '13px',
      boxSizing: 'border-box'
    },
    addBtn: {
      padding: '8px 16px',
      backgroundColor: '#3b82f6',
      color: 'white',
      border: 'none',
      borderRadius: '6px',
      fontSize: '13px',
      fontWeight: '500',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      marginTop: '12px'
    },
    removeBtn: {
      padding: '6px',
      backgroundColor: '#fee2e2',
      color: '#dc2626',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '12px',
      fontWeight: '600'
    },
    errorMessage: {
      backgroundColor: '#fee2e2',
      color: '#991b1b',
      padding: '12px',
      borderRadius: '6px',
      fontSize: '14px',
      marginBottom: '16px'
    },
    footer: {
      padding: '16px 24px',
      borderTop: '1px solid #e5e7eb',
      display: 'flex',
      gap: '12px',
      justifyContent: 'flex-end',
      backgroundColor: '#f9fafb'
    },
    btnCancel: {
      padding: '10px 20px',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      backgroundColor: 'white',
      color: '#374151'
    },
    btnSubmit: {
      padding: '10px 20px',
      border: 'none',
      borderRadius: '6px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      backgroundColor: '#3b82f6',
      color: 'white'
    },
    emptyState: {
      textAlign: 'center',
      padding: '40px 20px',
      color: '#9ca3af',
      fontSize: '14px'
    }
  };

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={styles.header}>
          <h2 style={styles.title}>
            {statusToEdit ? 'Edit Project Status' : 'Update Project Status'}
          </h2>
          <button 
            style={styles.closeBtn}
            onClick={onClose}
            onMouseOver={(e) => e.target.style.backgroundColor = '#f3f4f6'}
            onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            &times;
          </button>
        </div>

        <div style={styles.body}>
          <div style={styles.projectInfo}>
            <h3 style={styles.projectInfoTitle}>{project.project_name}</h3>
            <p style={styles.projectInfoSubtitle}>Manager: {project.project_manager?.name}</p>
          </div>

          <div style={styles.tabs}>
            <button
              style={styles.tab(activeTab === 'basic')}
              onClick={() => setActiveTab('basic')}
            >
              Basic Info
            </button>
            {/* <button
              style={styles.tab(activeTab === 'tasks')}
              onClick={() => setActiveTab('tasks')}
            >
              Pending Tasks ({formData.pending_tasks.length})
            </button> */}
            {formData.status === 'READY_TO_OUTSOURCE' && (
              <button
                style={styles.tab(activeTab === 'outsource')}
                onClick={() => setActiveTab('outsource')}
              >
                Outsource Resources ({formData.outsource_resources.length})
              </button>
            )}
          </div>

          <form onSubmit={handleSubmit}>
            {/* BASIC TAB */}
            {activeTab === 'basic' && (
              <>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Select Status *</label>
                  <div style={styles.statusOptions}>
                    {statusOptions.map(option => (
                      <label 
                        key={option.value}
                        style={styles.statusOption(formData.status === option.value, option.color)}
                      >
                        <input
                          type="radio"
                          name="status"
                          value={option.value}
                          checked={formData.status === option.value}
                          onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                          style={styles.hiddenRadio}
                        />
                        <div style={styles.statusOptionContent}>
                          <span style={styles.statusIcon}>{option.icon}</span>
                          <span style={styles.statusLabel}>{option.label}</span>
                        </div>
                      </label>
                    ))}
                  </div>
                </div>

                <div style={styles.formGroup}>
                  <label htmlFor="remarks" style={styles.label}>Remarks *</label>
                  <textarea
                    id="remarks"
                    rows="4"
                    placeholder="Provide context or details about this status update..."
                    value={formData.remarks}
                    onChange={(e) => setFormData({ ...formData, remarks: e.target.value })}
                    required
                    style={styles.textarea}
                  />
                  <small style={styles.charCount}>{formData.remarks.length} characters</small>
                </div>

                <div style={styles.formGroup}>
                  <label htmlFor="attachment" style={styles.label}>Upload File (Optional)</label>
                  <input
                    id="attachment"
                    type="file"
                    onChange={(e) => setAttachmentFile(e.target.files[0])}
                    style={styles.fileInput}
                  />
                  {attachmentFile && (
                    <small style={styles.charCount}>Selected: {attachmentFile.name}</small>
                  )}
                </div>

                <div style={styles.formGroup}>
                  <label htmlFor="google_drive_link" style={styles.label}>
                    Google Drive Link (Optional)
                  </label>
                  <input
                    id="google_drive_link"
                    type="url"
                    placeholder="https://drive.google.com/..."
                    value={formData.google_drive_link}
                    onChange={(e) => setFormData({ ...formData, google_drive_link: e.target.value })}
                    style={styles.input}
                  />
                </div>
              </>
            )}

            {/* PENDING TASKS TAB */}
            {activeTab === 'tasks' && (
              <div>
                <button
                  type="button"
                  style={styles.addBtn}
                  onClick={addPendingTask}
                  onMouseOver={(e) => e.target.style.backgroundColor = '#2563eb'}
                  onMouseOut={(e) => e.target.style.backgroundColor = '#3b82f6'}
                >
                  <span>+</span> Add Pending Task
                </button>

                {formData.pending_tasks.length > 0 ? (
                  <div style={{ overflowX: 'auto', marginTop: '16px' }}>
                    <table style={styles.table}>
                      <thead>
                        <tr>
                          <th style={styles.tableHeader}>Sl. No</th>
                          <th style={styles.tableHeader}>Pending Task</th>
                          <th style={styles.tableHeader}>Resource</th>
                          <th style={styles.tableHeader}>Status</th>
                          <th style={styles.tableHeader}>Closing Date</th>
                          <th style={styles.tableHeader}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formData.pending_tasks.map((task, index) => (
                          <tr key={index}>
                            <td style={styles.tableCell}>{index + 1}</td>
                            <td style={styles.tableCell}>
                              <textarea
                                style={styles.tableInput}
                                value={task.task_description}
                                onChange={(e) => updatePendingTask(index, 'task_description', e.target.value)}
                                placeholder="Task description"
                                rows="2"
                              />
                            </td>
                            <td style={styles.tableCell}>
                              <input
                                type="text"
                                style={styles.tableInput}
                                value={task.resource}
                                onChange={(e) => updatePendingTask(index, 'resource', e.target.value)}
                                placeholder="Resource"
                              />
                            </td>
                            <td style={styles.tableCell}>
                              <select
                                style={styles.tableSelect}
                                value={task.task_status}
                                onChange={(e) => updatePendingTask(index, 'task_status', e.target.value)}
                              >
                                <option value="PENDING">Pending</option>
                                <option value="IN_PROGRESS">In Progress</option>
                                <option value="COMPLETED">Completed</option>
                                <option value="BLOCKED">Blocked</option>
                              </select>
                            </td>
                            <td style={styles.tableCell}>
                              <input
                                type="date"
                                style={styles.tableInput}
                                value={task.closing_date}
                                onChange={(e) => updatePendingTask(index, 'closing_date', e.target.value)}
                              />
                            </td>
                            <td style={styles.tableCell}>
                              <button
                                type="button"
                                style={styles.removeBtn}
                                onClick={() => removePendingTask(index)}
                                onMouseOver={(e) => e.target.style.backgroundColor = '#fecaca'}
                                onMouseOut={(e) => e.target.style.backgroundColor = '#fee2e2'}
                              >
                                ×
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div style={styles.emptyState}>
                    No pending tasks added yet
                  </div>
                )}
              </div>
            )}

            {/* OUTSOURCE RESOURCES TAB */}
            {activeTab === 'outsource' && formData.status === 'READY_TO_OUTSOURCE' && (
              <div>
                <button
                  type="button"
                  style={styles.addBtn}
                  onClick={addOutsourceResource}
                  onMouseOver={(e) => e.target.style.backgroundColor = '#2563eb'}
                  onMouseOut={(e) => e.target.style.backgroundColor = '#3b82f6'}
                >
                  <span>+</span> Add Resource
                </button>

                {formData.outsource_resources.length > 0 ? (
                  <div style={{ overflowX: 'auto', marginTop: '16px' }}>
                    <table style={styles.table}>
                      <thead>
                        <tr>
                          <th style={styles.tableHeader}>Sl. No</th>
                          <th style={styles.tableHeader}>Resource Name</th>
                          <th style={styles.tableHeader}>Roles</th>
                          <th style={styles.tableHeader}>Years of Exp</th>
                          <th style={styles.tableHeader}>Projects Worked On</th>
                          <th style={styles.tableHeader}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formData.outsource_resources.map((resource, index) => (
                          <tr key={index}>
                            <td style={styles.tableCell}>{index + 1}</td>
                            <td style={styles.tableCell}>
                              <input
                                type="text"
                                style={styles.tableInput}
                                value={resource.resource_name}
                                onChange={(e) => updateOutsourceResource(index, 'resource_name', e.target.value)}
                                placeholder="Name"
                              />
                            </td>
                            <td style={styles.tableCell}>
                              <textarea
                                style={styles.tableInput}
                                value={resource.roles}
                                onChange={(e) => updateOutsourceResource(index, 'roles', e.target.value)}
                                placeholder="Roles"
                                rows="2"
                              />
                            </td>
                            <td style={styles.tableCell}>
                              <input
                                type="number"
                                step="0.1"
                                style={styles.tableInput}
                                value={resource.years_of_experience}
                                onChange={(e) => updateOutsourceResource(index, 'years_of_experience', e.target.value)}
                                placeholder="Years"
                              />
                            </td>
                            <td style={styles.tableCell}>
                              <textarea
                                style={styles.tableInput}
                                value={resource.projects_worked_on}
                                onChange={(e) => updateOutsourceResource(index, 'projects_worked_on', e.target.value)}
                                placeholder="Projects"
                                rows="2"
                              />
                            </td>
                            <td style={styles.tableCell}>
                              <button
                                type="button"
                                style={styles.removeBtn}
                                onClick={() => removeOutsourceResource(index)}
                                onMouseOver={(e) => e.target.style.backgroundColor = '#fecaca'}
                                onMouseOut={(e) => e.target.style.backgroundColor = '#fee2e2'}
                              >
                                ×
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div style={styles.emptyState}>
                    No outsource resources added yet
                  </div>
                )}
              </div>
            )}

            {error && (
              <div style={styles.errorMessage}>
                {error}
              </div>
            )}
          </form>
        </div>

        <div style={styles.footer}>
          <button 
            type="button" 
            style={styles.btnCancel}
            onClick={onClose}
            disabled={loading}
            onMouseOver={(e) => !loading && (e.target.style.backgroundColor = '#f9fafb')}
            onMouseOut={(e) => !loading && (e.target.style.backgroundColor = 'white')}
          >
            Cancel
          </button>
          <button 
            onClick={handleSubmit}
            style={{
              ...styles.btnSubmit,
              opacity: loading ? 0.7 : 1,
              cursor: loading ? 'not-allowed' : 'pointer'
            }}
            disabled={loading}
            onMouseOver={(e) => !loading && (e.target.style.backgroundColor = '#2563eb')}
            onMouseOut={(e) => !loading && (e.target.style.backgroundColor = '#3b82f6')}
          >
            {loading ? (statusToEdit ? 'Updating...' : 'Creating...') : (statusToEdit ? 'Update Status' : 'Create Status')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateStatusModal;